import log from 'sentry/log'
import { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actionCreators as api } from 'reduxBits/api'
import { setUserSuspendedType } from 'reduxBits/chat/actions'

const useChannelInfoData = ({ selectedChannel, recipient }) => {
  const [recipientIsBankIdVerified, setRecipientIsBankIdVerified] = useState()
  const [advertiserType, setAdvertiserType] = useState()

  const { suspendedAccount: suspendedAccountFeature } = useSelector(
    (state) => state.optimizely.features,
  )
  const { userId, custom: recipientCustom } = recipient
  const { url, custom: selectedChannelCustom } = selectedChannel

  const dispatch = useDispatch()

  const isVerifiedCheck = useCallback(
    (channelInfo) => {
      setRecipientIsBankIdVerified(
        channelInfo?.members?.find((member) => member.sendbirdAccountId === userId)?.bankIdVerified,
      )
    },
    [userId],
  )

  useEffect(
    function setBankIdVerifiedByCustom() {
      if (recipientCustom?.bankIdVerified) {
        setRecipientIsBankIdVerified(recipientCustom?.bankIdVerified)
      }
    },
    [recipientCustom?.bankIdVerified],
  )

  useEffect(
    function setAdvertiserTypeByCustom() {
      if (selectedChannelCustom?.advertiserType) {
        setAdvertiserType(selectedChannelCustom?.advertiserType)
      }
    },
    [selectedChannelCustom?.advertiserType],
  )

  useEffect(() => {
    if (!url) return

    const fetchData = async () => {
      const endpoint = `messaging-sendbird-communication/v1/channel-info/${url}`
      try {
        const { channelInfo, ad } = await dispatch(api.fetch(endpoint))
        const adAdvertiserType = ad?.advertiser?.type

        if (userId) {
          isVerifiedCheck(channelInfo)
        }

        if (adAdvertiserType) {
          setAdvertiserType(adAdvertiserType)
        }
      } catch (error) {
        const { content, response } = error

        if (
          suspendedAccountFeature?.enabled &&
          response?.status === 403 &&
          content?.error === '400301_account_suspended'
        ) {
          log.message(`SuspendedUser error: ${error}. Endpoint: ${endpoint}`)
          return dispatch(setUserSuspendedType(content.error))
        }

        log.error(new Error(`Fetch failed on ${endpoint}', ${error}`))
      }
    }
    fetchData()
  }, [dispatch, userId, url, isVerifiedCheck, suspendedAccountFeature?.enabled])

  return {
    recipientIsBankIdVerified,
    advertiserType,
  }
}

export default useChannelInfoData
